import React from 'react'
import { Card, Tabs } from 'antd'
import { PageHeader } from '@components'

import SingleAdd from './SingleAdd'
import BatchAdd from './BatchAdd'

export default function LeadAddSdrPage () {
  const items = [
    {
      label: '单个上传',
      key: 'single',
      children: <SingleAdd />,
    },
    {
      label: '批量上传',
      key: 'batch',
      children: <BatchAdd />,
    },
  ]
  return (
    <>
      <PageHeader title="上传企微孵化线索" ghost={false} />
      <Card className="mt20">
        <Card className="mt20" style={{ width: '750px' }}>
          <Tabs items={items} />
        </Card>
      </Card>
    </>
  )
}
